import { IQuestionConfig } from '../core/IQuestion';
import { IGenericQuestionProvider } from '../core/question-provider/IQuestionProvider';
import { MiniWizardViewModel } from '../core/MiniWizardViewModel';
import { Step } from '../../Step';
import { FC, useEffect, useRef } from 'react';
import { isPlatform } from '@ionic/react';
import { TextField } from '../../../components/TextField';

const questionType = 'name' as const;
type IQuestionType = typeof questionType;

type INameValue = { firstName: string; lastName: string; };
type INameQuestionProps = { lastNameLabel?: string; };

export type INameQuestion = IQuestionConfig<IQuestionType, INameValue, INameQuestionProps >;

export class NameQuestionProvider implements IGenericQuestionProvider<INameQuestion> {
    questionType = questionType;

    validate = (question: INameQuestion) => (question.answer?.firstName || '').length > 0;

    render = (question: INameQuestion, wizard: MiniWizardViewModel) => {
        return <NameStepV2 question={question} wizard={wizard} />;
    };
}

export const NameStepV2: FC<{ question: INameQuestion; wizard: MiniWizardViewModel }> = ({
    question, wizard
}) => {
    const firstNameFieldRef = useRef<HTMLIonInputElement>(null);

    useEffect(() => {
        if (isPlatform('desktop') || isPlatform('capacitor')) {
            const timer = setTimeout(() => {
                if (firstNameFieldRef.current && !question.answer?.firstName) {
                    firstNameFieldRef.current.setFocus();
                }
            }, 350);
            return () => clearTimeout(timer);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const firstNameChanged = (value: string) => {
        wizard.answer({
            ...question.answer,
            firstName: value
        });
    };

    const lastNameChanged = (value: string) => {
        wizard.answer({
            ...question.answer,
            lastName: value
        });
    };

    return (
        <Step question={question.questionTitle} >
            <TextField
                inputRef={firstNameFieldRef}
                label="First Name"
                name="firstname"
                value={question.answer?.firstName || ''}
                autocapitalize="words"
                onInput={firstNameChanged}
            />
            <TextField
                label={`${question.lastNameLabel || 'Last Name (optional)'}`}
                value={question.answer?.lastName || ''}
                name="lastname"
                autocapitalize="words"
                onInput={lastNameChanged}
            />
        </Step>
    );
};
